/**
 * Which roles may change a patient's email, company and password on the edit
 * patient form. Mirrors PatientEditAuthorization.AssertCanChangeRestrictedField
 * in Phoenix_Back_End (S3DEV2-7664): the backend returns a 403 for anyone else,
 * so the form hides those fields instead of letting the save fail.
 *
 * The FE never sees the raw role for SaaS users: transformUserRole
 * (utils/misc.js) renames admin-elevated CompanyAdministrator -> ServiceAdmin
 * and OfficeAdministrator -> ServiceCoach at login. The backend checks the
 * stored role, so both are listed here.
 *
 * Contracted employees are blocked by the backend whatever their role, so they
 * get false too. Unknown, missing, or not-yet-loaded roles fall through to false.
 */
export const PATIENT_EMAIL_COMPANY_EDIT_ROLES = [
  "Administrator",
  "CompanyAdministrator",
  "OfficeAdministrator",
  "ServiceAdmin",
  "ServiceCoach",
  "SleepCoach"
];

export const PATIENT_PASSWORD_EDIT_ROLES = ["Administrator"];

export const canEditPatientEmailAndCompany = (role, contractedEmployee) =>
  !contractedEmployee && PATIENT_EMAIL_COMPANY_EDIT_ROLES.includes(role);

export const canEditPatientPassword = (role, contractedEmployee) =>
  !contractedEmployee && PATIENT_PASSWORD_EDIT_ROLES.includes(role);

/**
 * Which restricted fields the patient form shows. Create (no route :id) shows
 * all of them; the backend doesn't restrict these fields on create. Edit
 * (/patients/:id/edit) shows only what this role may change.
 */
export const getPatientFormFieldVisibility = (
  patientRouteId,
  role,
  contractedEmployee
) => {
  const isEdit = Boolean(patientRouteId);
  return {
    showEmailAndCompany:
      !isEdit || canEditPatientEmailAndCompany(role, contractedEmployee),
    showPassword: !isEdit || canEditPatientPassword(role, contractedEmployee)
  };
};
